import { useEffect, useState } from 'react';
import M from 'materialize-css';
import mutationHooks from '../../common/mutationHooks/index.ts';

const OtherSettings = ({ user }) => {
  const initValues = () => ({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    suspectMedEmailAddress: '',
    userContactId: '',
  });

  const [values, setValues] = useState(initValues());

  const { mutate: updateOtherSettings } =
    mutationHooks.user.useUpdateOtherSettings();

  const onChange = ({ target: { id, value } }) =>
    setValues(p => ({ ...p, [id]: value }));

  const submit = e => {
    e.preventDefault();
    updateOtherSettings(values);
  };

  useEffect(() => {
    if (!user) {
      return;
    }
    const { firstName, lastName, primaryContact, suspectMedEmailAddress } =
      user;
    const userContact = primaryContact?.userContact;

    setValues(prev => ({
      ...prev,
      firstName: firstName,
      lastName: lastName,
      phoneNumber:
        userContact?.type === 'phone' ? userContact?.contactInfo : '',
      suspectMedEmailAddress: suspectMedEmailAddress || '',
      userContactId: userContact?.id,
    }));
  }, [user]);

  useEffect(() => {
    M.updateTextFields();
  }, [values]);

  return (
    <div>
      <p>
        <b>Other Settings</b>
      </p>
      <div className="row">
        <div className="input-field col s12 m4">
          <input
            id="firstName"
            type={'text'}
            value={values.firstName}
            onChange={onChange}
          />
          <label htmlFor="firstName">First Name</label>
        </div>
        <div className="input-field col s12 m4">
          <input
            id="lastName"
            type={'text'}
            value={values.lastName}
            onChange={onChange}
          />
          <label htmlFor="lastName">Last Name</label>
        </div>
      </div>

      {user?.primaryContact?.userContact?.type === 'phone' ? (
        <div className="row">
          <div className="input-field col s12 m4">
            <input
              id="phoneNumber"
              type={'text'}
              value={values.phoneNumber}
              onChange={onChange}
            />
            <label htmlFor="phoneNumber">Phone Number</label>
          </div>
        </div>
      ) : null}

      <div className="row">
        <div className="input-field col s12 m4">
          <input
            id="suspectMedEmailAddress"
            type={'text'}
            value={values.suspectMedEmailAddress}
            onChange={onChange}
          />
          <small className="grey-text">
            This email will be used to receive responses from the FDA when you
            report illegitimate medications. Please ensure you provide a valid
            email that is used frequently for these notifications.
          </small>
          <label htmlFor="suspectMedEmailAddress">
            Suspect Med Email Address
          </label>
        </div>
      </div>

      <div className="row" style={{ marginTop: '40px' }}>
        <button
          onClick={submit}
          className="btn btn-small blue white-text waves-effect waves-light col s12 m4 l2"
          disabled={!values.firstName || !values.lastName}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default OtherSettings;
